<template>
  <div class="style-appbar d-flex align-items-center scss-title px-3">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "AppBar",
  data() {
    return {};
  },
};
</script>

<style scoped>
.style-appbar {
  box-shadow: 0px 4px 5px rgba(210, 210, 210, 255);
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: #f8f8f8;
  min-height: 60px;
  height: 60px;
}
</style>
